import type {DateUTC} from '@hconnect/common/types'

export const signalStatuses = ['Undefined', 'Ok', 'Warning', 'Alarm'] as const
export type SignalStatus = (typeof signalStatuses)[number]

export enum ThresholdLimit {
  HIGH_HIGH = 'HighHigh',
  HIGH = 'High',
  LOW = 'Low',
  LOW_LOW = 'LowLow'
}

export type LastModelBreach = {
  dateTime: DateUTC
  value: number
}

export type SignalReading = {
  value?: number
  status: SignalStatus
  unit?: string
  recorded?: DateUTC
  limit?: ThresholdLimit
}

export type SensorReadings = {
  [id: string]: {
    lastReading: SignalReading | undefined
    lastModelBreach: LastModelBreach | undefined
  }
}

export interface SignalData {
  localName: string
  description?: string
  group?: string
  unit?: string
  svgId: string
  lastReading?: SignalReading
  lastModelBreach?: LastModelBreach
  hasPredictionModel?: boolean
}

export interface MetricSignalMapping {
  svgId: string
  localNames: string[]
}

export interface SignalAnomaly {
  localName: string
  status: SignalStatus
  svgId: string
  value: number
}
